// Named constants for string-literal values used across the QASettings pages.
export const ReportCategory = {
  DIAGNOSIS: "diagnosis",
  ABA: "aba",
} as const;
export type ReportCategoryValue = (typeof ReportCategory)[keyof typeof ReportCategory];
